"use strict";
/**
 * Resolving a `TLabel` to a translated string against the shared catalog.
 *
 * Silo-level overrides layer on top of the shared translation table, so a
 * partner deployment customises strings without forking the core file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateLabel = translateLabel;
const index_1 = require("./index");
const label_1 = require("./label");
/**
 * Checks silo-namespaced keys first (`<siloKey>:<labelKey>` then
 * `<parentSilo>:<labelKey>`), then the bare key, then the label's
 * `defaultText` fallback. Supports `singular`/`plural`/`count` in
 * `formatParams` for grammatical number.
 */
function translateLabel({ label, language, formatParams = label_1.EMPTY_OBJECT, parentSilo = undefined, siloKey = undefined, }) {
    // If no key is provided, use the default text without translation
    if (label.key == null) {
        return formatParams ? (0, label_1.formatString)(label.defaultText, formatParams) : label.defaultText;
    }
    const labelKey = (0, label_1.labelToKey)(label);
    let defaultText = label.defaultText;
    let extra = {};
    const singularLabel = formatParams?.singular;
    const pluralLabel = formatParams?.plural;
    const count = formatParams?.count;
    if (singularLabel && pluralLabel) {
        if (count === 1) {
            extra = {
                noun: translateLabel({ label: singularLabel, language, parentSilo, siloKey }),
                isAre: translateLabel({ label: (0, label_1.t)('common.is', 'is'), language, parentSilo, siloKey }),
            };
        }
        else {
            extra = {
                noun: translateLabel({ label: pluralLabel, language, parentSilo, siloKey }),
                isAre: translateLabel({ label: (0, label_1.t)('common.are', 'are'), language, parentSilo, siloKey }),
            };
        }
    }
    const effectiveLanguage = language ?? 'en-US';
    const translations = index_1.allTranslations[effectiveLanguage];
    if (!translations) {
        console.error('No translations for ' + effectiveLanguage);
    }
    let translatedText;
    // Look up silo-specific and parent PSM translation first, see
    const silosToCheck = [siloKey, parentSilo].filter((key) => key != null);
    for (const silo of silosToCheck) {
        if (silo && translations) {
            const namespacedKey = `${silo}:${labelKey}`;
            translatedText = translations[namespacedKey];
            if (translatedText)
                break;
        }
    }
    if (!translatedText) {
        translatedText = translations ? translations[labelKey] : undefined;
    }
    // If no translation found, use the default text from the TLabel
    if (!translatedText) {
        const englishOnly = defaultText.startsWith('!');
        if (englishOnly) {
            defaultText = defaultText.slice(1);
        }
        translatedText = defaultText;
        if (effectiveLanguage !== 'en-US' && !englishOnly) {
            console.error('No translation for ' + labelKey + ' in ' + effectiveLanguage + ', using default text');
        }
    }
    if (formatParams) {
        translatedText = (0, label_1.formatString)(translatedText || labelKey, { ...formatParams, ...extra });
    }
    return translatedText || labelKey;
}
//# sourceMappingURL=translate-label.js.map